<template>
  <div class="org-manage content">
    <div class="employeeInfo-layout-left">
      <merchantTree
        v-if="detailLoaded"
        ref="tree"
        source="1"
        :showGroupLeader="isIFA"
        url="/buz/merchant/read/tree"
        :query="{ isOwner: 1 }"
        style="width: 100%"
        @add="$refs.addOrg.open(curTreeData)"
        @change="treeChange"
      />
    </div>
    <div class="right-panel" v-loading="loading" :style="{ width: 'calc(100vw - ' + (leftWidth - 15) + ')px' }">
      <div>
        <div class="search-box">
          <div class="input-item">
            <span class="label">姓名</span>
            <Input v-model="searchParams.name" placeholder="请输入" clearable />
          </div>
          <div class="input-item">
            <span class="label">英文名</span>
            <Input v-model="searchParams.englishName" placeholder="请输入" clearable />
          </div>
          <div class="input-item">
            <span class="label">手机号</span>
            <Input v-model="searchParams.mobile" placeholder="请输入" clearable />
          </div>
          <div class="input-item">
            <span class="label">工号</span>
            <Input v-model="searchParams.staffNo" placeholder="请输入" clearable />
          </div>
          <div v-if="isIFA" class="input-item">
            <span class="label">账号类型</span>
            <RadioGroup v-model="searchParams.ifaType" @on-change="searchAjax()">
              <Radio label="">全部</Radio>
              <Radio label="1">正式</Radio>
              <Radio label="2">潜在</Radio>
            </RadioGroup>
          </div>
          <div class="btn-item">
            <Button type="primary" @click="searchAjax()">搜索</Button>
            <Button type="primary" ghost @click="resetAccountList()">重置</Button>
          </div>
        </div>
        <div class="tools-box">
          <div class="info-box">
            <div class="info-box-l">
              <div :class="userInfo.orgStatus == 2 ? 'dian red' : 'dian green'"></div>
              <div class="text1">{{ merchantName }}</div>
              <template v-if="isIFA">
                <span class="text2 first"><Icon type="ios-person-outline" /><span>正式IFA</span></span>
                <span class="text3">{{ ifaStatistic.formalIfaNum || 0 }}</span>
                <span class="text2"><Icon type="ios-person-outline" /><span>潜在IFA</span></span>
                <span class="text3">{{ ifaStatistic.potentialIfaNum || 0 }}</span>
              </template>
            </div>
          </div>
          <div>
            <Button v-if="isGroup" type="error" @click="delGroup()">删除团队</Button>
            <Button v-if="isGroup" type="success" @click="onEditRelationalItem(null)">编辑团队</Button>
            <Button v-if="userInfo.merchantType != 3 && !isIFA" type="warning" @click="addGroup()">新增团队</Button>
            <Button type="primary" @click="editUser()">新增员工</Button>
            <!-- <Button type="primary" @click="importData()">批量导入</Button> -->
            <Button type="error" @click="batchDelet">批量删除</Button>
            <!-- <Button type="warning" @click="daochu(0)">导出</Button> -->
            <Button type="warning" @click="daochu(1)">导出全部</Button>
          </div>
        </div>

        <div class="table-box">
          <loading :isShow="listLoading" />
          <div class="employeeInfo-layout">
            <div class="employeeInfo-layout-right">
              <!-- <div class="left-box">
                <Checkbox :disabled="total == 0" v-model="isAll" @on-change="selectAll">全部</Checkbox>
                <span class="select-text"
                  >已选择<span class="num">{{ isAll ? total : selectArr.length }}/{{ total }}</span
                  >项</span
                >
              </div> -->
              <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
                <!-- 业务员 -->
                <template slot-scope="{ row }" slot="name">
                  <div class="user-box">
                    <span :class="row.ifaType == 2 ? 'gray' : 'dian'"></span>
                    <i class="iconfont iconduichang" v-if="row.isLeader == 1"></i>
                    <span class="user-name">{{ row.name }}</span>
                    <span v-if="row.englishName" class="user-name">({{ row.englishName }})</span>
                  </div>
                </template>
                <!-- 账号 -->
                <template slot-scope="{ row }" slot="account">
                  <span class="text">{{ row.account }}</span>
                  <template v-if="row.account && !row.eyeShow_account">
                    <i class="iconfont iconyincang eye-icon" @click="openEye(row, 'account', 1)"></i>
                  </template>
                </template>
                <!-- 手机号 -->
                <template slot-scope="{ row }" slot="mobile3">
                  <span class="text" v-if="row.eyeShow">{{ row.mobile }}</span>
                  <span class="text" v-else>{{ row.mobile3 }}</span>
                  <template v-if="row.mobile3">
                    <i class="iconfont iconyincang eye-icon" v-if="!row.eyeShow" @click="openEye(row)"></i>
                  </template>
                </template>
                <template slot-scope="{ row }" slot="status">
                  <i-Switch size="large" v-model="row.status" @on-change="changeStatus(row, $event)" false-value="0" true-value="1">
                    <span slot="open">启用</span> <span slot="close">禁用</span>
                  </i-Switch>
                </template>
                <template slot-scope="{ row }" slot="action">
                  <template v-if="isIFA">
                    <Dropdown :transfer="true" trigger="click" transfer-class-name="salesman-manage-dropdown-menu">
                      <a href="javascript:void(0)">
                        操作
                        <Icon type="ios-arrow-down"></Icon>
                      </a>
                      <template #list>
                        <DropdownMenu>
                          <DropdownItem @click.native="editUser(row)">
                            <span :disabled="row.isSubUser == 1"><Icon size="18" type="ios-create-outline" />编辑</span>
                          </DropdownItem>
                          <DropdownItem @click.native="relationModalOpen(row)">
                            <span> <i size="14" class="iconfont iconlishiguanxi"></i>变更记录</span>
                          </DropdownItem>
                          <DropdownItem @click.native="resetPassword(row)">
                            <span :disabled="row.isSubUser == 1"><i size="14" class="iconfont iconzhongzhimima"></i>重置密码</span>
                          </DropdownItem>
                          <DropdownItem @click.native="$refs.rankUpdateForm.open({ ...row, type: '1' })">
                            <span class="btn"> <Icon size="14" type="ios-trending-up" />晋升 </span>
                          </DropdownItem>
                          <DropdownItem @click.native="$refs.rankUpdateForm.open({ ...row, type: '4' })">
                            <span class="btn"> <Icon size="14" type="ios-trending-down" />降级 </span>
                          </DropdownItem>
                          <DropdownItem @click.native="$refs.activeChangeRef.open(row)">
                            <span> <Icon size="14" type="ios-checkmark-circle-outline" />active状态管理 </span>
                          </DropdownItem>
                          <DropdownItem @click.native="(row.isDel != 0 || row.isSubUser != '0') && delUser(row)">
                            <Tooltip v-if="row.isDel == 0 && row.isSubUser == '0'" placement="top-end" transfer word-wrap width="200">
                              <span class="btn" style="text-indent: -2px; color: red" :disabled="row.isDel == 0 && row.isSubUser == '0'" @click="delUser(row)"
                                ><Icon size="18" type="ios-trash-outline" />删除</span
                              >
                              <template #content>
                                <div>员工有佣金或为团队长<br />时不可删除</div>
                              </template>
                            </Tooltip>
                            <span class="btn" v-else style="text-indent: -2px; color: red" :disabled="row.isSubUser == 1" @click="delUser(row)"
                              ><Icon size="18" type="ios-trash-outline" />删除</span
                            >
                          </DropdownItem>
                        </DropdownMenu>
                      </template>
                    </Dropdown>
                  </template>
                  <template v-else>
                    <span class="table-btn" :disabled="row.isSubUser == 1" @click="editUser(row)">编辑</span>
                    <span class="table-btn" :disabled="row.isSubUser == 1" @click="resetPassword(row)">重置密码</span>
                    <Tooltip v-if="row.isDel == 0 && row.isSubUser == '0'" placement="top-end" transfer word-wrap width="200">
                      <span class="table-btn" :disabled="row.isDel == 0 && row.isSubUser == '0'" style="color: red" @click="delUser(row)">删除</span>
                      <template #content>
                        <div>员工有佣金或为团队长<br />时不可删除</div>
                      </template>
                    </Tooltip>
                    <span v-else class="table-btn" :disabled="row.isSubUser == 1" style="color: red" @click="delUser(row)">删除</span>
                  </template>
                </template>
              </Table>
              <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增团队 -->
    <add-org ref="addOrg" @success="onAddOrgSuccess" @editPassword="item => resetPassword(item)"></add-org>
    <!-- 新增/编辑员工 -->
    <edit-user ref="editUser" @success="getList" @editPassword="item => resetPassword(item)"></edit-user>
    <!-- 重置密码 -->
    <password-form ref="passwordForm"></password-form>
    <!-- 导入 -->
    <import-tool ref="importTool" @success="initData"></import-tool>
    <merDetailModal ref="merDetailModal" />
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
    <!-- 变更职级 -->
    <rank-update-form ref="rankUpdateForm" @success="getList"></rank-update-form>

    <activeChangeModal ref="activeChangeRef"></activeChangeModal>
    <!-- 变更记录 -->
    <relationModal ref="relationModalRef"></relationModal>
  </div>
</template>

<script>
import addOrg from './components/addOrg';
import editUser from './components/editUser';
import { pageTool, common } from '@/api/mixins';
import passwordForm from './components/passwordForm';
import activeChangeModal from './components/activeChangeModal';
import merchantTree from '@/components/commons/merchantTree/merchantTree';
import importTool from '@/components/commons/importTool/index2';
import rankUpdateForm from './components/rankUpdateForm';
import lzDicTxt from '@/components/commons/lzDicTxt';
import validUserName from '@/components/commons/validUserName';
import merDetailModal from './merDetailModal.vue';
import vipLevelMixin from '@/api/vipLevelMixin';
import relationModal from './components/relationModal.vue';

export default {
  mixins: [pageTool, common, vipLevelMixin],
  components: {
    merchantTree,
    importTool,
    passwordForm,
    activeChangeModal,
    addOrg,
    editUser,
    lzDicTxt,
    validUserName,
    merDetailModal,
    rankUpdateForm,
    relationModal
  },
  provide() {
    return {
      parent: this
    };
  },
  data() {
    return {
      isAll: false,
      searchParams: {
        name: '',
        mobile: '',
        status: '',
        groupId: '',
        ifaType: ''
      },
      leftWidth: 300,
      loading: false,
      curTreeData: {},
      detail: {},
      userInfo: {},
      selectArr: [], //表格选择的数据
      btnAuth: '', //按钮权限
      groupTableColumns: [
        {
          title: '团队名称',
          key: 'name',
          align: 'center'
        }
      ],
      groupTableData: [],
      accountQueryParams: {},
      groupList: [],
      detailLoaded: false,
      merchantName: '',
      ifaStatistic: {
        formalIfaNum: 0,
        potentialIfaNum: 0
      }
    };
  },
  computed: {
    isIFA() {
      return this.userInfo?.isIFA;
    },
    // 是否是团队
    isGroup() {
      return this.curTreeData?.nodeType == 2;
    },
    jiti() {
      return this.userInfo?.merchantType == 3;
    },
    columns() {
      let columns = [];
      if (this.isIFA) {
        columns.push(
          {
            type: 'selection',
            width: 60,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '业务员姓名',
            slot: 'name',
            align: 'center',
            minWidth: 190
          },
          {
            title: '工号',
            key: 'staffNo',
            minWidth: 120,
            align: 'center'
          },
          {
            title: '账号类型',
            key: 'ifaType',
            minWidth: 100,
            align: 'center',
            render(h, params) {
              const value = params.row.ifaType;
              if (value == 1) {
                return <span>正式</span>;
              } else if (value == 2) {
                return <span>潜在</span>;
              } else {
                return <span></span>;
              }
            }
          },
          {
            title: '销售职级',
            key: 'ifaLevel',
            minWidth: 80,
            align: 'center',
            render(h, params) {
              const value = params.row.ifaLevel;
              let ifaLevelMap = {
                0: '',
                1: '萌新',
                2: '新贵',
                3: '精英',
                4: '王者'
              };
              return <span>{ifaLevelMap[value]}</span>;
            }
          },
          {
            title: '团队长-级别',
            key: 'isLeader',
            minWidth: 150,
            align: 'center',
            render(h, params) {
              const leaderName = params.row.leaderName;
              const groupLevel = params.row.groupLevel; //团队级别 1合伙人 2高级合伙人
              const groupLevelMap = {
                1: '合伙人',
                2: '高级合伙人'
              };
              return (
                <span>
                  {leaderName}-{groupLevelMap[groupLevel]}
                </span>
              );
            }
          },
          {
            title: '推荐人',
            key: 'refereeName',
            minWidth: 120,
            align: 'center'
          },
          {
            title: '辅导人',
            key: 'mentorName',
            minWidth: 120,
            align: 'center'
          }
        );
        if (!this.jiti) {
          columns.push({
            title: '所属团队',
            key: 'groupName',
            minWidth: 180,
            align: 'center'
          });
        }

        columns.push(
          {
            title: '育成人',
            key: 'trainerName',
            minWidth: 120,
            align: 'center'
          },
          {
            title: ' licence有效期',
            key: 'status',
            width: 190,
            align: 'center',
            render(h, params) {
              if (params.row.ifaLicenceStartDate) {
                const value = params.row.ifaLicenceStartDate || '';
                const value1 = params.row.ifaLicenceEndDate || '';
                return (
                  <span>
                    {value.substr(0, 10)} 至 {value1.substr(0, 10)}
                  </span>
                );
              } else {
                return <span></span>;
              }
            }
          },
          {
            title: '手机号',
            slot: 'mobile3',
            minWidth: 130,
            align: 'center'
          },
          {
            title: '登录账号',
            slot: 'account',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '状态',
            slot: 'status',
            minWidth: 90,
            align: 'center'
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            width: '80',
            fixed: 'right'
          }
        );
      } else {
        columns.push(
          {
            type: 'selection',
            width: 60,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '业务员姓名',
            slot: 'name',
            align: 'center',
            minWidth: 140
          },
          {
            title: '手机号',
            slot: 'mobile3',
            minWidth: 130,
            align: 'center'
          },
          {
            title: '登录账号',
            slot: 'account',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '状态',
            slot: 'status',
            minWidth: 90,
            align: 'center'
          }
        );
        if (!this.jiti) {
          columns.push({
            title: '所属团队',
            key: 'groupName',
            minWidth: 130,
            align: 'center'
          });
        }
        columns.push({
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '180',
          fixed: 'right'
        });
      }
      return columns;
    }
  },
  created() {},
  mounted() {
    this.selectArr = [];
    this.isAll = false;
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (this.userInfo.isIFA) {
      this.setPageTitle('IFA管理');
    } else {
      this.setPageTitle('业务员管理');
    }
    this.getDetailData(); // 当前转介人信息
  },
  methods: {
    reloadRank() {
      this.getList();
    },
    initData() {
      this.getDetailData();
      this.$refs.tree.getTreeData(this.curTreeData.id);
      this.initListAjax('/buz/userBase/read/list');
    },
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        if (item.isDel == 0 && item.isSubUser == '0') {
          item._disabled = true;
          item._checked = false;
        }
        if (item.isDel == 1) {
          item._checked = status;
          item._disabled = status;
        }
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    // 批量删除
    batchDelet() {
      if (!this.selectArr.length && !this.isAll) {
        this.$notice.error('请至少选择一个业务员');
        return;
      }
      // 多选
      this.$notice.inquiry(`请确认是否批量删除这${this.isAll ? this.total : this.selectArr.length}位业务员？删除后将无此业务员数据`).then(() => {
        this.tableLoading = true;
        const data = {
          data: this.userInfo.tenantId,
          ids: this.selectArr.map(item => item.id),
          isAll: Number(this.isAll),
          ifaType: this.searchParams.ifaType
        };
        // 团队
        if (this.isGroup) {
          data.groupId = this.curTreeData.id;
        }
        this.$http({
          url: '/buz/userBase/batchDel',
          type: 'POST',
          data
        }).then(res => {
          this.selectArr = [];
          this.isAll = false;
          this.$notice.success('删除成功');
          this.initData();
        });
      });
    },
    // 导入员工
    importData() {
      let dickey = this.userInfo.merchantType == 3 ? 'USER_EXPORT_GROUP' : 'USER_EXPORT_BUSI';
      const dic = JSON.parse(localStorage.dic)[dickey];
      const key = Object.getOwnPropertyNames(dic)[0];
      const uploadParams = {};
      if (this.isGroup) {
        uploadParams.groupId = this.curTreeData.id;
      }
      if (this.jiti) {
        uploadParams.tenantId = this.curTreeData.id;
      }
      this.$refs.importTool.open({
        params: {},
        uploadParams,
        template: key,
        templateName: dic[key],
        uploadUrl: '/buz/userBase/batch/upload',
        errorUrl: '/buz/userBase/exportError',
        apiPermissionCode: 'org_2_3'
      });
    },
    daochu(isAll = 0) {
      this.loading = true;
      const params = JSON.parse(JSON.stringify(this.searchParams));
      params.isAll = isAll;
      this.$http({
        url: '/buz/userBase/batch/export',
        type: 'POST',
        responseType: 'blob',
        data: this.setListParams(params)
      })
        .then(res => {
          this.loading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 解密
    openEye(row, type, operationFunction = 2) {
      if (!row['validName' + type]) {
        this.$refs.validUserNameRef.open(row, type, operationFunction);
        return;
      }
      /**
       * operationFunction
       * 1-业务员详情
       * 2-转介人详情
       * 3-保单详情
       * 4-变更记录旧值
       * 5-变更记录新值
       * 6.客户详情解密
       * 7-客户导出解密
       * 8-注册用户信息
       * 9-保单变更记录解密
       * 11-运营后台账户解密
       * 12-内勤人员详情
       * 13-转介人活动解密
       * 14-预约管理解密
       * 15-转介人提现记录解密
       * 16-三要素验证解密
       * 17-周边服务订单
       * 18-结算
       * 19-建议书
       */
      /**
       * operationType
       * 1-证件号解密
       * 2-手机号解密
       * 3-银行卡号
       * 4-邮箱
       * 5-通讯地址
       * 6.身份证地址
       * 7-居住地地址
       * 8-通行证/护照号码
       * 9-公司/学校名称
       * 10-公司/学校地址
       * 11-保单号解密
       * 12-姓名
       * 13-姓名拼音
       * 14图片附件
       */
      /**
       * source;
       * 1、运营后台
       * 2、转介人后台
       * 3、小程序
       */
      /**
       * cardType
       * idcard_head 身份证头像面
       * idcard_back 身份证国微面
       * passport_head 港澳通行证、护照头像面
       * passport_back 港澳通行证反面
       * payment 缴费凭证
       * account  账户证明
       * pay_notice_pdf  续费通知书
       */
      /**
       * customerType
       * 1-投保人
       * 2-受保人
       * 3-受益人
       * 4-保单第二持有人
       * 99其他
       */
      /**
       * index
       * 用户类型为受益人时，数组下标
       */
      const typeMap = {
        'mobile': 2, // 手机号
        'address': 5, // 通讯地址
        'account': 0 // 账号
      };
      if (!type) {
        if (!row.eyeShow) {
          this.descrypt(
            {
              query: row.id,
              operationFunction: 1,
              operationType: 2
            },
            row,
            'mobile'
          ).then(() => {
            this.$set(row, 'eyeShow', true);
          });
        } else {
          this.$set(row, 'eyeShow', false);
        }
      } else {
        const ryrKey = `eyeShow_${type}`;
        if (!row[ryrKey]) {
          this.descrypt(
            {
              query: row.id,
              operationFunction: operationFunction,
              operationType: typeMap[type]
            },
            row,
            type
          ).then(() => {
            this.$set(row, ryrKey, true);
          });
        } else {
          this.$set(row, ryrKey, false);
        }
      }
    },
    listCallback(res) {
      this.tableData = res.data.map(item => {
        if (item.mobile) {
          item.mobile3 = item.mobile;
        }
        item._disabled = item.isDel == 0 && item.isSubUser == '0' ? true : false;
        this.selectArr.forEach(item2 => {
          if (item.id == item2.id) {
            item._checked = true;
          }
        });
        if (this.isAll && !item._disabled) {
          item._checked = true;
        }
        return item;
      });
    },
    changeStatus(row, status) {
      this.$notice
        .inquiry(`确认更新业务员状态？`)
        .then(() => {
          this.$http({
            url: '/buz/userBase/edit',
            type: 'POST',
            data: {
              id: row.id,
              status
            }
          }).then(res => {
            this.$notice.success('操作成功');
            this.getList();
          });
        })
        .catch(() => {
          row.status = status == '1' ? '0' : '1';
        });
    },
    editUser(row = {}) {
      let data = {
        id: row.id || '',
        orgName: this.userInfo.merchantName,
        tenantId: this.userInfo.tenantId
      };
      console.log('curTreeData--------', this.curTreeData);
      if (this.isGroup) {
        data.groupId = this.curTreeData.id;
        data.groupName = this.curTreeData.name;
      }
      data.leaderId = this.curTreeData.groupLeaderId;
      this.$refs.editUser.open(data);
    },
    // 转化参数
    setListParams(params) {
      if (this.jiti) {
        params.tenantId = this.curTreeData.id;
      } else {
        params.tenantId = this.userInfo.tenantId;
      }
      if (this.isGroup) {
        params.groupId = this.curTreeData.id;
      }
      return params;
    },
    async treeChange(data) {
      this.curTreeData = JSON.parse(JSON.stringify(data));
      this.merchantName = data.name || '';
      this.tableData = [];
      this.initListAjax('/buz/userBase/read/list');
      await this.getIfaStatistic();
    },
    getDetailData() {
      this.$http({
        url: '/buz/merchant/curr/detail',
        type: 'POST',
        data: {
          id: this.userInfo.tenantId
        }
      }).then(res => {
        res.data.mobile = res.data.mobile1;
        res.data.childNum = res.data.childNum || 0;
        res.data.agentNum = res.data.agentNum || 0;
        res.data.vipLevel = (res.data.vipLevel || '') + '';
        this.setVipLevelList(res.data.vipLevel);
        this.detail = res.data;
        this.merchantName = res.data.merchantName || '';
        this.detailLoaded = true;
        if (this.isIFA) {
          this.getIfaStatistic();
        }
      });
    },
    // 获取IFA统计信息
    async getIfaStatistic() {
      const params = {};
      if (this.isGroup) {
        params.groupId = this.curTreeData.id;
      }
      try {
        const res = await this.$http({
          url: '/buz/userBase/statistic',
          type: 'POST',
          data: params
        });
        this.ifaStatistic = {
          formalIfaNum: res.data.formalIfaNum || 0,
          potentialIfaNum: res.data.potentialIfaNum || 0
        };
      } catch (e) {
        console.error('获取IFA统计失败', e);
      }
    },
    // 删除业务员
    delUser(item) {
      if (item.isDel == 0) {
        return;
      }
      this.$notice.inquiry('请确认是否删除此业务员？删除后将无此业务员数据').then(async () => {
        this.$http({
          url: '/buz/userBase/del',
          type: 'GET',
          data: {
            id: item.id
          }
        }).then(res => {
          this.$notice.success('操作成功');
          this.pageNum = 1;
          this.selectArr = this.selectArr.filter(item2 => item2.id != item.id);
          this.getList();
          this.getDetailData();
        });
      });
    },
    relationModalOpen(row) {
      this.$refs.relationModalRef.open({ userId: row.id });
    },
    // 重置密码
    resetPassword(item) {
      this.$refs.passwordForm.open(item);
    },
    // 新增团队
    addGroup() {
      this.$refs.addOrg.open({
        nodeType: 0,
        id: this.userInfo.tenantId
      });
    },
    delGroup() {
      this.$notice.inquiry('是否确认删除？').then(() => {
        this.$http({
          url: '/buz/groupBase/batchDel',
          type: 'POST',
          data: {
            ids: [this.curTreeData.id]
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.$refs.tree.getTreeData();
        });
      });
    },
    onEditRelationalItem() {
      const row = JSON.parse(JSON.stringify(this.curTreeData));
      this.$refs.addOrg.open(row, true);
    },
    resetAccountList() {
      this.searchParams = {
        name: '',
        mobile: '',
        status: '',
        groupId: '',
        ifaType: ''
      };
      this.$refs.tree.getTreeData();
    },
    searchAjax() {
      this.$refs.tree.getTreeData();
    },
    onAddOrgSuccess() {
      this.$refs.tree.getTreeData();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './merchantManage.scss';
</style>

<style lang="scss">
.salesman-manage-dropdown-menu {
  max-height: 280px;
  .ivu-dropdown-item {
    color: #515c6f;
    font-size: 14px !important;
    padding: 8px 11px;

    i {
      font-size: 14px;
      margin-right: 5px;
    }
  }

  .ivu-dropdown-item-disabled {
    color: #c7cad1;
  }

  .btn[disabled] {
    color: #c7cad1 !important;
  }
}
</style>
